import Vue from 'vue'
import apiService, { RestError } from 'services/api-service'
import domUtils from 'util/dom-utils'
import globalConfig from 'init/global.config'
import globalStore, { Store } from 'init/global-store'
import paginateMixin from 'mixins/paginate-mixin'
import Question from 'components/question/question'
import qaConfig from 'widgets/qa/qa.config'
import logger from 'util/logger'

import withRender from './related-questions-list.html'
import './related-questions-list.scss'

export default withRender(Vue.extend({
  data() {
    return {
      relatedQuestions: [],
      store: globalStore
    }
  },
  components: {
    'tt-question': Question
  },
  mixins: [paginateMixin],
  props: {
    submissionCtx: Object
  },
  computed: {
    currentSku(): string {
      return (this.store as Store).sku
    },
    qaConfig() {
      return qaConfig
    }
  },
  methods: {
    fetchData(isPageChange) {
      if (this.currentSku && (this.offset === 0 || this.offset <= this.total)) {
        const limit = this.offset === 0 ? qaConfig.relatedInitialPageSize : qaConfig.relatedPageSize
        apiService.relatedQuestionsList({
          sku: this.currentSku,
          offset: this.offset,
          limit,
          sort: qaConfig.defaultSortOption
        }).then((data) => {
          this.relatedQuestions = data.relatedQuestions
          this.total = data.total
          if (isPageChange) {
            // not first time, so most likely paginated.  Will only scroll up, not down
            this.$nextTick(() => {
              domUtils
                .scrollUpToRef(this.$refs, 'relQList', globalConfig.additionalPagingScroll)
              // TT-11837 - focus header after scroll. safeFocus in case client hides the header
              // timeout is to wait for it to scroll up
              setTimeout(() => domUtils.safeFocus(() => this.$refs.heading), 500)
            })
          }
        }).catch((e: RestError) => {
          if (e.errorCode === 'turnto-offline') {
            logger.info('TurnTo is in offline mode - related questions not loaded', e)
          } else {
            logger.info('Error loading related question data for the Q&A widget', e)
          }
        })
      }
    }
  },
  created() {
    // initialPageSize and pageSize are in paginateMixin
    this.initialPageSize = qaConfig.relatedInitialPageSize
    this.pageSize = qaConfig.relatedPageSize

    this.fetchData()
  },
  watch: {
    currentSku() {
      // onQueryChange method in paginateMixin
      this.onQueryChange()
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/related-questions-list/related-questions-list.ts